module.exports = __webpack_public_path__ + "static/media/truck1.3cd62173.jpg";